export default "__VITE_ASSET__e2be4380__"